import type { ModuleGridLane } from "../models/ModuleGrid.js";

export interface SpaceshipLanePage {
  readonly pageIndex: number;
  readonly pageCount: number;
  readonly visibleRows: number;
  readonly rowOffset: number;
}

export function clampPageIndex(index: number, pageCount: number): number {
  if (pageCount <= 1) return 0;
  if (!Number.isFinite(index)) return 0;
  return Math.max(0, Math.min(pageCount - 1, Math.trunc(index)));
}

export function resolveSpaceshipLanePage(
  gridHeight: number,
  lanes: readonly ModuleGridLane[] | undefined,
  requestedPageIndex: number,
  maxVisibleRows: number,
): SpaceshipLanePage {
  const pageCount = Math.max(1, lanes?.length ?? 0);
  const pageIndex = clampPageIndex(requestedPageIndex, pageCount);
  const visibleRows = Math.max(1, Math.min(gridHeight, maxVisibleRows));
  const maxOffset = Math.max(0, gridHeight - visibleRows);
  const lane = lanes?.[pageIndex];
  const focusY = lane ? lane.start.y : Math.floor(gridHeight / 2);
  const rowOffset = Math.max(0, Math.min(maxOffset, focusY - Math.floor(visibleRows / 2)));
  return { pageIndex, pageCount, visibleRows, rowOffset };
}
